import { IDocumentoNoExigible } from "../models/documentosObligatorios/idocumentosObligatorios";
import { Documents } from "../models/request/documents";

export class DocumentosDigitalesManager {
  private static documentosMotivoSolicitud: any[];
  private static contentDocuments: Documents[] = [];
  private static indexMotivoSolicitudJson: number;
  private static soporteDigitalRNEC: File;

  public static getDocumentosMotivoSolicitud() {
    return this.documentosMotivoSolicitud;
  }

  public static getIndexMotivoSolicitud() {
    return this.indexMotivoSolicitudJson;
  }

  public static setDocumentosSolicitud(
    documentosDeSolicitud: any,
  ) {
    this.contentDocuments = [];
    this.documentosMotivoSolicitud =
      documentosDeSolicitud;
  }

  public static retirarDocumentosNoExigibles(
    documentosPropietarioEncontrados: IDocumentoNoExigible[],
    tipoIdentidadTitular: string,
    numIdentificacionTitular: string,
    tipoIdentidadBeneficiario: string,
    numIdentificacionBeneficiario: string,
  ) {

    const documentosObligatorios = this.documentosMotivoSolicitud.filter(
      (documentoSolicitud) => {
        const documento: Documents = this.mapearAContentDocument(
          documentoSolicitud,
          documentosPropietarioEncontrados,
          tipoIdentidadTitular,
          numIdentificacionTitular,
          tipoIdentidadBeneficiario,
          numIdentificacionBeneficiario
        );
        return !documento.digitalSupport;
      }
    );

    const documentosEliminados = this.documentosMotivoSolicitud.filter(
      (documentoSolicitud) => !documentosObligatorios.includes(documentoSolicitud)
    );

    return { documentosObligatorios, documentosEliminados };
  }

  private static mapearAContentDocument(
    documentoSolicitud: any,
    documentosEncontrados: IDocumentoNoExigible[],
    tipoIdentidadTitular: string,
    numIdentificacionTitular: string,
    tipoIdentidadBeneficiario: string,
    numIdentificacionBeneficiario: string
  ) {

    const documentoEncontradoPorId = documentosEncontrados.find(
      (documentoEncontrado) => {
        const esIdTipoDocumento =
          documentoEncontrado.idTipoDocumento ==
          documentoSolicitud.idTipoDocumento;
        const esPropietario =
          documentoEncontrado.propietario == documentoSolicitud.propietario;
        return esIdTipoDocumento && esPropietario;
      }
    );
    const esDocumentoDigitalnoExigible = !!documentoEncontradoPorId;
    const propietarioEsTitular = documentoSolicitud.propietario == "T";
    const tipoIdentificacionPropietario = propietarioEsTitular
      ? tipoIdentidadTitular
      : tipoIdentidadBeneficiario;
    const numIdentificacionPropietario = propietarioEsTitular
      ? numIdentificacionTitular
      : numIdentificacionBeneficiario;
    let document = new Documents(
      documentoSolicitud.id,
      documentoSolicitud.label,
      !esDocumentoDigitalnoExigible,
      esDocumentoDigitalnoExigible,
      numIdentificacionPropietario,
      documentoSolicitud.idTipoDocumento,
      tipoIdentificacionPropietario
    );
    document.idForm = documentoSolicitud.idForm;

    if (documentoEncontradoPorId) {
      document.name = documentoEncontradoPorId.nombre;
      document.description = documentoSolicitud.label;
      document.documentoPropietario =
        documentoEncontradoPorId.documentoPropietario;
    }

    this.contentDocuments.push(document);

    return document;
  }
}
